import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
const SearchParamsSchema = z.object({
    invite: z.string().optional()
});
export const Route = createFileRoute('/org/$organization/settings/subscription/')({
    validateSearch: (search)=>SearchParamsSchema.parse(search)
});
